import { useEffect, useState } from "react"
import { useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import { GetProductsLookupDocument } from "@/graphql/codegen/graphql"
import type { Lookup, LookupQueriesProductsArgs, Query } from "@/graphql/codegen/graphql"

interface UseGetProductsLookupReturn {
  products: Lookup[]
  fetching: boolean
}

export const useGetProductsLookup = ({
  query,
  productIds,
}: {
  query: string
  productIds?: string[]
}): UseGetProductsLookupReturn => {
  const [products, setProducts] = useState<Lookup[]>([])

  const [{ data, fetching }] = useQuery<Pick<Query, "lookup">, LookupQueriesProductsArgs>({
    query: GetProductsLookupDocument,
    variables: {
      input: {
        filter: {
          ...(query && query?.length > 1 && { query }),
          ...(productIds?.length && { productIds }),
        },
        limit: FULL_LIST_LIMIT,
        offset: 0,
      },
    },
  })

  useEffect(() => {
    if (data?.lookup?.products?.__typename === "LookupSuccess") {
      setProducts(data.lookup.products.items)
    }
  }, [data])

  return {
    products,
    fetching,
  }
}
